import { AppType } from "@/features/applications";

import { Button, Divider, Modal, Tabs } from "antd";
import React, { useState } from "react";

import { defaultTab } from "./constants";
import { WLTabsContext } from "./hooks";
import { WatchlistTab, WatchlistType } from "../types";
import { useWatchListContext } from "../../hooks";

import AlertTable from "./AlertTable";
import Description from "./Description";
import WatchlistName from "./WatchlistName";
import WatchlistSetting from "./WatchlistSetting";
import WatchlistTable from "./WatchlistTable";
import styles from "./styles.less";
import { PlusOutlined } from "@ant-design/icons/lib";
import { useUserPreference, useWatchListUpdate } from "@/features/applications/hook";

const { TabPane } = Tabs;
const { confirm } = Modal;

export default () => {
  const { userWatchlist, updateWatchlist } = useWatchListUpdate();
  const { lastUpdate, activeKey, setActiveKey } = useWatchListContext();
  const [panes, setPanes] = useState<WatchlistTab[]>(getDefaultWatchlist());
  const { userPreference, updateUserPreference } = useUserPreference();
  const [tableType, setTableType] = useState<WatchlistType>("watchlist");
  const [selectedStocks, setSelectedStocks] = useState<AppType.TickerExchange[]>([]);
  const [alertModal, setAlertModal] = useState(false);

  return (
    <WLTabsContext.Provider value={{ selectedStocks, setSelectedStocks, alertModal, setAlertModal }}>
      <Tabs
        onChange={onTabChange}
        activeKey={activeKey}
        type="editable-card"
        hideAdd
        tabBarExtraContent={
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={add}>
            New Watchlist
          </Button>
        }
        onEdit={(targetKey, action) => action === "remove" && remove(targetKey as string)}
      >
        {panes.map(pane => (
          <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
            <WatchlistName
              selectedWatchlist={pane.title}
              setActiveKey={setActiveKey}
              setPanes={setPanes}
              tableType={tableType}
              setTableType={setTableType}
              paneKey={pane.key}
            />
            <Description tabKey={pane.key} />
            <WatchlistSetting tableType={tableType} />
            <Divider orientation="right" style={{ marginTop: 0 }}>
              <span className={styles.updateTime}>Last Update: {lastUpdate}</span>
            </Divider>
            {tableType === "watchlist" || pane.key === "all" ? <WatchlistTable /> : <AlertTable />}
          </TabPane>
        ))}
      </Tabs>
    </WLTabsContext.Provider>
  );

  function add() {
    const title = `New Watchlist ${panes.length}`;

    setPanes([...panes, { title, content: [], key: `new-watchlist-${panes.length}`, closable: true }]);
    updateWatchlist({ ...userWatchlist, [title]: [] });
  }

  function remove(targetKey: string) {
    confirm({
      title: `Do you want to delete watchlist: ${panes.find(e => e.key === targetKey)!.title}?`,
      content: "This action is unable to undo.",
      maskClosable: true,
      okType: "danger",
      onOk() {
        setActiveKey("all");
        setPanes(panes.filter(pane => pane.key !== targetKey));
        const newWatchlist = { ...userWatchlist };
        delete newWatchlist[panes.find(e => e.key === targetKey)!.title];

        updateWatchlist(newWatchlist);
      },
      onCancel() {}
    });
  }

  function getDefaultWatchlist(): WatchlistTab[] {
    return [
      ...defaultTab,
      ...Object.keys(userWatchlist).map(k => ({
        title: k,
        content: userWatchlist[k] as AppType.TickerExchange[],
        key: k,
        closable: true
      }))
    ];
  }

  function onTabChange(newKey: string) {
    setActiveKey(newKey);
    updateUserPreference({ ...userPreference, lastVisitedWatchlist: newKey });
  }
};
